let popup = document.querySelector('.popup');

if(popup !== null) {
  let popupClose = document.querySelectorAll('.js-popup-close');


  // show the popup if it hasn't been seen.
  if(!getCookie("popupSeen")){
    popup.classList.remove('popup--closed');
  }



  if(popupClose !== null) {
    popupClose.forEach((closeButton) => {
      closeButton.addEventListener('click', () => {
        popup.classList.add('popup--closed');
        document.cookie = 'popupSeen=true; expires=1 Nov 2026 00:00:00 UTC; path=/'
      });
    });
  }

  function getCookie(data){
      var dset = data + "=";
      var c = document.cookie.split(';');
      for(var i=0; i<c.length; i++){
          var val = c[i];
          while (val.charAt(0)==' ') val = val.substring(1, val.length);
          if(val.indexOf(dset) == 0) return val.substring(dset.length, val.length)
      }

      return "";
  }
}
